import React from "react";
import { Loader } from "react-loaders";
import "./OverlayLoading.css";

class OverlayLoading extends React.Component {
  render() {
    return (
      <div className="overlay-loader">
        {this.props.loading ? (
          <div className="loader-center">
            <Loader type="line-scale" />
            <h3 style={{ color: '#ffffff' }}>加載中...</h3>
          </div>
        ) : null}

        {this.props.children}
      </div>
    );
  }
}

export default OverlayLoading;
